const valueToPrecision = (value?: number | string | null, precisionValue = 2): string =>
  value ? Number(Number(value).toFixed(precisionValue)).toLocaleString() : '0';

export default valueToPrecision;
